import { ObjectWithMethod } from '@/types/ObjectWithMethod';

export const removeMethodProperty = <T extends ObjectWithMethod>({
  _method,
  ...rest
}: T) => rest;
